<template>
  <v-container fluid>
    <v-row class="px-8 pt-1">
      <v-col cols="3" class="pr-4 pl-3">
        <v-btn depressed color="primary" @click="create">
          <span>Ajouter un article</span>
        </v-btn>
      </v-col>
      <v-col cols="9">
        <v-row>
          <v-col cols="4" class="py-0">
            <v-row justify="space-around">
              <v-checkbox
                class="label my-0 py-0"
                label="De Bac à Bac+3"
                :value="3"
                v-model="searchByDegreeType"
              ></v-checkbox>
              <v-checkbox
                class="label my-0 py-0"
                label="De Bac+3 à Bac+6"
                :value="1"
                v-model="searchByDegreeType"
              ></v-checkbox>
            </v-row>
          </v-col>
          <v-col cols="3" class="pt-0">
            <div class="d-flex align-center justify-end">
              <v-select
                v-model="searchByTopic"
                :items="topics"
                item-value="id"
                item-text="name"
                hide-details
                outlined
                :disabled="!searchByDegreeType"
                label="Topic"
                no-data-text="Pas de données disponibles"
                clearable
              >
              </v-select>
            </div>
          </v-col>
          <v-col cols="2" class="pt-0">
            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="searchByDate"
                  readonly
                  hide-details
                  outlined
                  clearable
                  dense
                  label="Date"
                  width="290"
                  v-on="on"
                >
                  <template v-slot:append>
                    <v-icon v-on="on" v-text="'fas fa-calendar-alt'"></v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="searchByDate"
                no-title
                scrollable
                :max="$moment(new Date()).format('YYYY-MM-DD')"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3" class="pt-0">
            <v-text-field
              label="Titre"
              hide-details
              outlined
              dense
              @keydown="checkEnter"
              v-model="searchByTitle"
            >
              <template v-slot:append>
                <v-btn
                  depressed
                  color="primary"
                  class="topBar-search ma-0"
                  @click="getNewsByTitle"
                >
                  <v-icon v-text="'fas fa-search'"></v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <TableDefault
      :headers="headers"
      :items="items"
      :totalPage="totalPage"
      :totalItem="totalItem"
      :limit="limit"
      :currentPage="currentPage"
      @edit="getNewsEdit"
      @remove="remove"
      @changePage="changePage"
      @changeItemPerPage="changeItemPerPage"
    />
  </v-container>
</template>

<script>
import TableDefault from "@/components/tables/TableDefault";
import newsService from "@/services/news";
import topicService from "@/services/topic";

export default {
  name: "News",
  components: { TableDefault },
  data: () => ({
    headers: [
      {
        text: "ID",
        field: "id",
        width: "50px"
      },
      {
        text: "Topic",
        field: "name",
        fieldArray: "topics",
        width: "400px"
      },
      {
        text: "Date",
        field: "date"
      },
      {
        text: "Titre",
        field: "title"
      },
      {
        text: "Éditeur",
        field: "author"
      },
      {
        text: "Action",
        action: true,
        width: "130px"
      }
    ],
    items: [],
    topics: [],
    totalPage: 1,
    totalItem: 0,
    currentPage: 1,
    limit: 50,
    searchByTitle: "",
    searchByTopic: "",
    searchByDate: "",
    searchByDegreeType: ""
  }),
  created() {
    this.getNews();
  },
  methods: {
    checkEnter(event) {
      if (event.code === "Enter") {
        this.getNews();
      }
    },
    changePage(page) {
      this.currentPage = page;
      this.getNews();
    },
    changeItemPerPage(limit) {
      this.limit = limit;
      this.getNews();
    },
    create() {
      this.$store.dispatch("resetNews");
      this.$router.push({ name: "NewsCreate" });
    },
    getNewsByTitle() {
      this.currentPage = 1;
      this.getNews();
    },
    async getTopicsByDegreeType() {
      let res = await topicService.getTopicsByDegreeType({
        degreeType: this.searchByDegreeType
      });
      if (res) {
        this.searchByTopic = "";
        this.topics = res.data;
      }
    },
    async getNews() {
      let res = await newsService.getNewsPagination({
        limit: this.limit,
        currentPage: this.currentPage,
        searchByTitle: this.searchByTitle,
        searchByTopic: this.searchByTopic,
        searchByDate: this.searchByDate,
        searchByDegreeType: this.searchByDegreeType
      });
      if (res) {
        this.items = res.data.data;
        this.totalPage = res.data.totalPage;
        this.totalItem = res.data.totalItem;
      }
    },
    async getNewsEdit(news) {
      let res = await newsService.getDetail(news.id);
      if (res) {
        this.$store.dispatch("setNews", res.data);
        this.$router.push({
          name: "NewsEdit"
        });
      }
    },
    async remove(news) {
      await this.$store.dispatch("removeNews", news);
      this.getNews();
    }
  },
  watch: {
    searchByDegreeType: function(value) {
      if (value === null) {
        this.searchByDegreeType = "";
      }
      this.currentPage = 1;
      this.getNews();
      this.getTopicsByDegreeType();
    },
    searchByTopic: function(value) {
      if (value === undefined) {
        this.searchByTopic = "";
      }
      this.currentPage = 1;
      this.getNews();
    },
    searchByDate: function(value) {
      if (value === null) {
        this.searchByDate = "";
      }
      this.currentPage = 1;
      this.getNews();
    }
  }
};
</script>
<style lang="sass">
.v-menu__content
  .v-card
    margin: 0
.radio-group .col
  padding: 0 12px
.v-input--selection-controls .v-radio>.v-label
  color: #000
  font-weight: 400
.v-input__icon
  height: 18px
</style>
